import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

/**
 * Persistent gate for users approved WITH conditions.  While
 * `conditions_ack_required` is true the platform's protected endpoints
 * (Shop / Trade / Order) return 403.  This banner sits in the layout
 * so the partner can read the conditions and acknowledge them in one click.
 */
export function ConditionsAckBanner() {
  const { user, api, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.role === "admin") return null;
  if (!user.conditions_ack_required || !user.conditions) return null;

  const ack = async () => {
    setBusy(true);
    try {
      await api.post("/users/me/conditions/ack");
      toast.success("Conditions acknowledged — Shop and Trade unlocked.");
      await refresh?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save your acknowledgement.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="conditions-ack-banner"
         className="fixed top-0 left-0 right-0 z-[70] border-b border-[#D8B23E]/50 bg-[#D8B23E]/[0.12] backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 py-3 flex flex-col md:flex-row md:items-start gap-3">
        <div className="flex-1 min-w-0">
          <div className="overline text-[#D8B23E] flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#D8B23E] animate-pulse"></span>
            Approval carries conditions — Shop &amp; Trade locked until acknowledged
          </div>
          <div className="font-body text-sm text-[#F5F5F0] mt-2 whitespace-pre-line leading-relaxed line-clamp-3">
            {user.conditions}
          </div>
        </div>
        <button data-testid="ack-conditions-btn" onClick={ack} disabled={busy}
                className="rounded-full bg-[#D8B23E] text-black px-6 py-2 font-grotesk text-[10px] uppercase tracking-[0.2em] hover:opacity-90 transition-opacity disabled:opacity-50 self-start md:self-center whitespace-nowrap">
          {busy ? "Saving…" : "I acknowledge"}
        </button>
      </div>
    </div>
  );
}
